import type { Middleware } from "openapi-fetch";

import { handleUnauthorized } from "./unauthorizedHandler";

// Сессия истекла или её нет: 401 → обработчик из `setUnauthorizedHandler`
// (по умолчанию — переход на `/login?next=…`). Ответ дальше превращается в `ApiError`.
export const authMiddleware: Middleware = {
  onResponse({ response }) {
    if (response.status === 401) {
      handleUnauthorized();
    }
    return undefined;
  },
};
